export default "__VITE_ASSET__CaaoECbn__"